import React from 'react';
import ReactDOM from 'react-dom';
import {
    Router,
    Route,
    browserHistory,
} from 'react-router';

import App from './containers/app/app';
import TopStories from './containers/top-stories/top-stories';

import './index.css';

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path='/' component={App}>
        <Route path='/stories' component={TopStories} />
        <Route path='/stories/:currentFilter' component={TopStories} />
    </Route>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js